
import React from "react";
import "./StatusDash.css";
import { useDispatch, useSelector } from "react-redux";
import getIntervalParams from "../../Helper/getIntervalParams";
import {
  getOperationFilteredDataInit,
  setActiveSearch,
  setSelectedCard as setSelected,
  setSearchFields,
} from "../../../redux/slices/operationHomeSlice";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

export const CallStatsDashboard = () => {
  const dispatch = useDispatch();

  const callStats = useSelector((state) => state.operationHome.cards.stats);
  const activeTab = useSelector((state) => state.operationHome.activeTab);
  const startDate = useSelector((state) => state.operationHome.tabStartDate);
  const endDate = useSelector((state) => state.operationHome.tabEndDate);
  const selected = useSelector((state) => state.operationHome.cards.selected);
  const pageSize = useSelector((state) => state.operationHome.table.pageSize);

  const filterTableData = (value, type) => {
    const body = {
      search: "callStatus",
      searchText: value,
      page: 1,
      type: type || "",
    };
    const params = getIntervalParams(activeTab, startDate, endDate);
    params.limit = pageSize;
    dispatch(getOperationFilteredDataInit({ body, params }));
  };
  console.log("callStats vm", callStats.VMopen);
  console.log("callStats all", callStats.calls);

  const handleOpen = () => {
    dispatch(setSearchFields({}));
    filterTableData("yes");
    dispatch(setActiveSearch(""));
    dispatch(setSelected("open"));
  };

  const handleClosed = () => {
    dispatch(setSearchFields({}));
    filterTableData("closed");
    dispatch(setActiveSearch(""));
    dispatch(setSelected("closed"));
  };

  const handleInProgress = () => {
    dispatch(setSearchFields({}));
    filterTableData("In-Progress");
    dispatch(setActiveSearch(""));
    dispatch(setSelected("in-progress"));
  };

  const handleOpenVoice = () => {
    dispatch(setSearchFields({}));
    filterTableData("Open", "voicemail");
    dispatch(setActiveSearch(""));
    dispatch(setSelected("open-voice"));
  };

  const handleClosedVoice = () => {
    dispatch(setSearchFields({}));
    filterTableData("Closed", "voicemail");
    dispatch(setActiveSearch(""));
    dispatch(setSelected("closed-voice"));
  };

  const handleInProgressVoice = () => {
    dispatch(setSearchFields({}));
    filterTableData("In-Progress", "voicemail");
    dispatch(setActiveSearch(""));
    dispatch(setSelected("in-progress-voice"));
  };

  const getAverageDuration = (duration, total) => {
    const totalSec =
      Number(duration.hour || duration.hours) * 3600 +
      Number(duration.minute || duration.minutes) * 60 +
      Number(duration.second || duration.seconds);
    const average = Math.floor(totalSec / Number(total));
    let minutes = Math.floor(average / 60);
    let seconds = average - minutes * 60;
    minutes = isNaN(minutes) ? 0 : minutes;
    seconds = isNaN(seconds) ? 0 : seconds;
    return `${minutes} min ${seconds} sec`;
  };

  const getTooltipContent = (status) => {
    if (!status) return "No data";
    return `High: ${status.high || 0}\nMedium: ${status.medium || 0}\nLow: ${
      status.low || 0
    }`;
  };

  return (
    <div className="dashboard">
      <div className="stat stat-overall">
        <h4 className="headTitle">Overall Call Stats:</h4>
        <div className="stats-row stats-row-overall">
          <div className="stat-card-stat">
            <div className="collapse-icon" />
            <h3 className="totalNo">Total No. of Calls</h3>
            <p className="stat-value">{callStats.calls || 0}</p>
            <p className="stat-label">Analyzed</p>
          </div>
          <div className="stat-card-stat">
            <div className="collapse-icon1" />
            <h3 className="averageCall">Average Call Duration</h3>
            <p className="stat-value stat-duration">
              {getAverageDuration(callStats.duration, callStats.calls)}
            </p>
            <p className="stat-label">Average length</p>
          </div>
        </div>
      </div>

      <div className="stat stat-identified">
        <h4 className="headTitle">Calls Identified for Follow Up:</h4>
        <div className="stats-row">
          {/* Open Conversations */}
          <div className="stat-card-group">
            <span className="card-pos">Open</span>
            <div
              className={`stat-card open clickable ${
                selected === "open" ? "active" : ""
              }`}
              style={{ backgroundColor: "#FFEFE6", color: "#000" }}
              onClick={handleOpen}
              data-tooltip-id="open-tooltip"
            >
              <p className="stat-value-data">
                {callStats.open || 0} (
                {(((callStats.open || 0) / (callStats.calls || 1)) * 100).toFixed(
                  0,
                )}
                %)
              </p>
              <p className="stat-labeling">Conversations</p>
            </div>
          </div>

          {/* In-Progress Conversations */}
          <div className="stat-card-group">
            <span className="card-pos">In-progress</span>
            <div
              className={`stat-card in-progress clickable ${
                selected === "in-progress" ? "active" : ""
              }`}
              style={{ backgroundColor: "#E6F0FF", color: "#000" }}
              onClick={handleInProgress}
              data-tooltip-id="in-progress-tooltip"
            >
              <p className="stat-value-data">
                {callStats.in_progress || 0} (
                {(
                  ((callStats.in_progress || 0) / (callStats.calls || 1)) *
                  100
                ).toFixed(0)}
                %)
              </p>
              <p className="stat-labeling">Conversations</p>
            </div>
          </div>

          {/* Closed Conversations */}
          <div className="stat-card-group">
            <span className="card-pos">Closed</span>
            <div
              className={`stat-card closed clickable ${
                selected === "closed" ? "active" : ""
              }`}
              style={{ backgroundColor: "#FCEAFF", color: "#000" }}
              onClick={handleClosed}
              data-tooltip-id="closed-tooltip"
            >
              <p className="stat-value-data">
                {callStats.closed || 0} (
                {(
                  ((callStats.closed || 0) / (callStats.calls || 1)) *
                  100
                ).toFixed(0)}
                %)
              </p>
              <p className="stat-labeling">Conversations</p>
            </div>
          </div>

          {/* Open Voice Mails */}
          <div className="stat-card-group">
            <span className="card-pos">Open</span>
            <div
              className={`stat-card clickable ${
                selected === "open-voice" ? "active" : ""
              }`}
              style={{ backgroundColor: "#FFEFE6", color: "#000" }}
              onClick={handleOpenVoice}
              data-tooltip-id="open-voice-tooltip"
            >
              <p className="stat-value-data">
                {callStats.VMopen || 0} (
                {(
                  ((callStats.VMopen || 0) / (callStats.calls || 1)) *
                  100
                ).toFixed(0)}
                %)
              </p>
              <p className="stat-labeling">Voice Mails</p>
            </div>
          </div>

          {/* In-Progress Voice Mails */}
          <div className="stat-card-group">
            <span className="card-pos">In-progress</span>
            <div
              className={`stat-card clickable ${
                selected === "in-progress-voice" ? "active" : ""
              }`}
              style={{ backgroundColor: "#E6F0FF", color: "#000" }}
              onClick={handleInProgressVoice}
              data-tooltip-id="in-progress-voice-tooltip"
            >
              <p className="stat-value-data">
                {callStats.VMinProgress || 0} (
                {(
                  ((callStats.VMinProgress || 0) / (callStats.calls || 1)) *
                  100
                ).toFixed(0)}
                %)
              </p>
              <p className="stat-labeling">Voice Mails</p>
            </div>
          </div>

          {/* Closed Voice Mails */}
          <div className="stat-card-group">
            <span className="card-pos">Closed</span>
            <div
              className={`stat-card clickable ${
                selected === "closed-voice" ? "active" : ""
              }`}
              style={{ backgroundColor: "#FCEAFF", color: "#000" }}
              onClick={handleClosedVoice}
              data-tooltip-id="closed-voice-tooltip"
            >
              <p className="stat-value-data">
                {callStats.VMclosed || 0} (
                {(
                  ((callStats.VMclosed || 0) / (callStats.calls || 1)) *
                  100
                ).toFixed(0)}
                %)
              </p>
              <p className="stat-labeling">Voice Mails</p>
            </div>
          </div>
        </div>
      </div>

      {/* Tooltips */}
      <Tooltip
        id="open-tooltip"
        place="top"
        content={getTooltipContent(callStats?.OpenStatus)}
        multiline
      />
      <Tooltip
        id="in-progress-tooltip"
        place="top"
        content={getTooltipContent(callStats?.InProgressStatus)}
        multiline
      />
      <Tooltip
        id="closed-tooltip"
        place="top"
        content={getTooltipContent(callStats?.ClosedStatus)}
        multiline
      />
      <Tooltip
        id="open-voice-tooltip"
        place="top"
        content={getTooltipContent(callStats?.VMOpenStatus)}
        multiline
      />
      <Tooltip
        id="in-progress-voice-tooltip"
        place="top"
        content={getTooltipContent(callStats?.VMInProgressStatus)}
        multiline
      />
      <Tooltip
        id="closed-voice-tooltip"
        place="top"
        content={getTooltipContent(callStats?.VMClosedStatus)}
        multiline
      />
    </div>
  );
};
